// extracted by mini-css-extract-plugin
export var screenLg = "992px";
export var screenXl = "1200px";
export var screenMd = "768px";
export var screenSm = "576px";
export var screenXlMax = "1199px";
export var screenLgMax = "991px";
export var screenMdMax = "767px";
export var screenSmMax = "575px";
export var TitleContent = "TitleContent-module--TitleContent--1QsEk";